module.exports = __webpack_public_path__ + "static/media/logo.ae554162.png";